import styles from './ProfileBanner.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Button } from 'seek-style-guide/react';

import SignInRegisterLink from 'SignInRegisterLink/SignInRegisterLink';
import { trackConversion } from 'store/experiments/experiments';
import { campaignLinkClicked } from 'store/location/location';
import Variant from 'Variant/Variant';

const mapDispatchToProps = dispatch => ({
  bannerClick: () => {
    dispatch(campaignLinkClicked({
      linkName: 'houston:logged+out+banner',
      trackingCode: 'sk:main:au:home:loggedoutbanner:profile:update+your+profile'
    }));
    dispatch(trackConversion('13e9b9de-0511-4555-a062-b4224326015e'));
  }
});

@connect(null, mapDispatchToProps)
export default class ProfileBanner extends Component {
  static propTypes = {
    bannerClick: PropTypes.func.isRequired
  };

  render() {
    const { bannerClick } = this.props;

    return (
      <div className={styles.root}>
        <div className={styles.content}>
          <p className={styles.text}>
            <Variant experiment="13e9b9de-0511-4555-a062-b4224326015e" variation={0}>
              <span>Update your SEEK Profile and let opportunity come to you.</span>
            </Variant>
            <Variant experiment="13e9b9de-0511-4555-a062-b4224326015e" variation={1}>
              <span>Your SEEK Profile never stops searching for your next job.</span>
            </Variant>
          </p>

          <SignInRegisterLink className={styles.button} intercept={bannerClick} mode="register">
            <Button color="pink">Update now</Button>
          </SignInRegisterLink>
        </div>
        <div className={styles.image} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/LoggedOutBanner/ProfileBanner/ProfileBanner.js
 **/